<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/Flow/Flow' }">办公审批</el-breadcrumb-item>
            <el-breadcrumb-item>发起审批</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="24">
          <span style="text-align:left">人事事务类</span><el-badge :value="renshiFlows.length" type="primary" />
          <el-divider></el-divider>
          <el-row :gutter="5">
            <el-col v-for="(item, index) in renshiFlows" :key="index" :span="3">
              <el-button type="primary" :icon="renshiIcon" @click="CreateTask(item.ID, item.Name)" plain
                circle></el-button>
              <div class="flowname"> {{ item.Name }}</div>
            </el-col>
          </el-row>
          <span style="text-align:left">行政事务类</span><el-badge :value="xingzhengFlows.length" type="warning" />
          <el-divider></el-divider>
          <el-row :gutter="5">
            <el-col v-for="(item, index) in xingzhengFlows" :key="index" :span="3">
              <el-button type="warning" :icon="xingzhengIcon" @click="CreateTask(item.ID, item.Name)" plain
                circle></el-button>
              <div class="flowname"> {{ item.Name }}</div>
            </el-col>
          </el-row>
          <span style="text-align:left;">运维事务类</span><el-badge :value="yunweiFlows.length" type="success" />
          <el-divider></el-divider>
          <el-row :gutter="5">
            <el-col v-for="(item, index) in yunweiFlows" :key="index" :span="3">
              <el-button type="success" :icon="yunweiIcon" @click="CreateTask(item.ID, item.Name)" plain
                circle></el-button>
              <div class="flowname"> {{ item.Name }}</div>
            </el-col>
          </el-row>
          <span style="text-align:left">财务事务类</span><el-badge :value="caiwuFlows.length" type="danger" />
          <el-divider></el-divider>
          <el-row :gutter="5">
            <el-col v-for="(item, index) in caiwuFlows" :key="index" :span="3">
              <el-button type="danger" :icon="caiwuIcon" @click="CreateTask(item.ID, item.Name)" plain
                circle></el-button>
              <div class="flowname"> {{ item.Name }}</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { Decrypt, Encrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { GetAllWorkFlow } from "../../until/ZeusApiSDK/Logic/WorkFLowLogic";
export default {
  data() {
    return {
      currentUser: {},
      removeflow: [],
      renshiFlows: [],
      xingzhengFlows: [],
      yunweiFlows: [],
      caiwuFlows: [],
      renshiIcon: "el-icon-user-solid",
      xingzhengIcon: "el-icon-s-help",
      caiwuIcon: "el-icon-s-ticket",
      yunweiIcon: "el-icon-s-tools"
    };
  },
  created() {
    this.getCurrentUser();
    this.InitFlows();
  },
  methods: {
    //获取当前用户
    getCurrentUser: function () {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    InitFlows: function () {
      GetAllWorkFlow().then(res => {
        if (res.length > 0) {
          res.forEach(element => {
            if (element.InstanceManager) {
              if (element.InstanceManager.indexOf(this.currentUser.UserId) < 0) {
                this.removeflow.push(element)
              }
            }
          });
          this.removeflow.forEach(element => {
            res.splice(jQuery.inArray(element, res), 1);
          });
          res.forEach(element => {
            if (element.Type === "人事事务类") {
              this.renshiFlows.push(element);
            } else if (element.Type == "行政事务类") {
              this.xingzhengFlows.push(element);
            } else if (element.Type == "运维事务类") {
              this.yunweiFlows.push(element);
            } else if (element.Type == "财务事务类") {
              this.caiwuFlows.push(element);
            }
          });
        }
      });
    },
    CreateTask: function (flowid, flowname) {
      var to = { name: "CreateTask", params: { flowid: flowid, flowname: flowname } };
      this.$router.push(to);
    }
  }
};
</script>
<style lang="less" scoped>
.flowname {
  color: #2c3e50;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 10px;
}
</style>